module.exports = __webpack_public_path__ + "img/chips200.21faca9e.png";